import React from "react";
import Timeline1973 from "../pages/our_story/Timeline1973";
import Timeline1978 from "../pages/our_story/Timeline1978";
import Timeline1989 from "../pages/our_story/Timeline1989";
import Timeline1991 from "../pages/our_story/Timeline1991";
import Timeline1998 from "../pages/our_story/Timeline1998";
import Timeline2006 from "../pages/our_story/Timeline2006";
import Timeline2008 from "../pages/our_story/Timeline2008";
import Timeline2010 from "../pages/our_story/Timeline2010";
import Timeline2012 from "../pages/our_story/Timeline2012";
import Timeline2014 from "../pages/our_story/Timeline2014";
import Timeline2016 from "../pages/our_story/Timeline2016";
import Timeline2023 from "../pages/our_story/Timeline2023";
import AnimatedTimelineItem from "./AnimatedTimelineItem";

const DesktopTimeline = () => {
  return (
    <div className="w-full">
      <AnimatedTimelineItem>
        <Timeline1973
          year="1973"
          loc="Branford, CT"
          bold="Massey's is founded"
          body="in a 3-car garage and begins work as a small commercial and residential firm"
        />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
        <Timeline1978
          year="1978"
          loc="Branford, CT"
          bold="Massey's moves to its new and current headquarters"
          body="on East Main Street in Branford, 
            this location would have future expansion in 1986, 1997, 1999, 2008, and 2014 builds new facility on Baldwin Drive"
        />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
        <Timeline1989
          year="1989"
          loc="New Haven, CT"
          bold="One Century Tower"
          body="becomes Massey's largest project yet, venturing into the world of healthcare
            construction and forging a relationship with Blue Cross Blue Shield"
        />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
        <Timeline1991
          year="1991"
          loc="Branford, CT"
          bold="Casino work"
          body="becomes a new Massey's specialty, beginning with Foxwoods Casino and Mohegan Sun
            shortly after"
        />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
        <Timeline1998
          year="1998"
          loc="Providence, RI"
          bold="Massey's opens their Providence office"
          body=""
        />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
        <Timeline2006
          year="2006"
          loc="Branford, CT"
          bold="Massey's partners with United Architectural Metals"
          body="for specialty unitized glazing projects"
        />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
      <Timeline2008
        year="2008"
        loc="Branford, CT"
        bold="All Panels Systems"
        body="is founded, establishing material suppliers and subcontractors in-house, 
            and beginning work in waterproofing and firestop (FM Global)"
      />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
      <Timeline2010
        year="2010"
        loc="Boston, MA"
        bold="Massey's comes to Boston"
        body="and begins its first large project there with the Boston Medical Menino Expansion"
      />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
      <Timeline2012
        year="2012"
        loc="Foxborough, MA"
        bold="The Foxborough office"
        body="opens its doors for the first time"
      />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
      <Timeline2014
        year="2014"
        loc="Boston, MA"
        bold="An outpour of Boston projects"
        body="paves the way for Massey's to become a top player in the city"
      />
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
      <Timeline2016
        year="2016"
        loc="Branford, CT"
        bold="Massey's partners with Fabbrica"
        body="for larger custom architectural and unitized facades across the Northeast"
      />
      
      </AnimatedTimelineItem>
      <AnimatedTimelineItem>
      <Timeline2023
        year="2023"
        loc="Franklin, MA"
        bold="Massey's celebrates 50 years"
        body="and sets up shop at its new Franklin office"
      />
      </AnimatedTimelineItem>
    </div>
  );
};

export default DesktopTimeline;
